export default "__VITE_ASSET__enxSiGVN__"